var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmilelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17289",
    "data-name": "\\u9577\\u65B9\\u5F62 17289",
    width: 28.387,
    height: 14.236
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18901",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18901",
    transform: "translate(-952 -5923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_17296",
    "data-name": "\\u9577\\u65B9\\u5F62 17296",
    transform: "translate(952 5923)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18875",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18875",
    transform: "translate(963 5946.895)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29188",
    "data-name": "\\u30D1\\u30B9 29188",
    d: "M2.1,0C.211,0,0,1.838,0,2.628a11.039,11.039,0,0,0,4,7.739,15.249,15.249,0,0,0,10.2,3.869,15.233,15.233,0,0,0,10.2-3.869,10.96,10.96,0,0,0,3.994-7.739C28.388,1.84,28.19,0,26.3,0a2.866,2.866,0,0,0-.5.048A54.035,54.035,0,0,1,14.2,1.338,54.888,54.888,0,0,1,2.589.048a2.675,2.675,0,0,0-.495-.04Z",
    transform: "translate(0 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilelogo);
export default __webpack_public_path__ + "static/media/smilelogo.62bec2814201f3043c93aee6afd0007f.svg";
export { ForwardRef as ReactComponent };